import React from "react"

export default class PasswordInput extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="row">
				<div className="col-sm-12">			
					<div className="PasswordInput">
						<span className="fa fa-lock" style={{left: 13, fontSize: 17}}></span>
						<input type="password" className="has-icon" {...this.props} />
					</div>
				</div>
			</div>
		);	
	}

}